import { AutoplayOptions, SwiperOptions } from "swiper/types";
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import { getRefs } from "./utils";

interface HeroCarouselProps {
  rootEl: HTMLElement;
}

const HeroCarousel = (props: HeroCarouselProps) => {
  const options: SwiperOptions = {
    speed: 1000,
    slidesPerView: 1,
    loop: true,
    direction: "vertical",
    allowTouchMove: false,
    touchStartPreventDefault: false,
  };

  const autoplayOptions: AutoplayOptions = {
    delay: 5000,
    disableOnInteraction: false,
  };

  const refs = getRefs(props.rootEl);

  if (!refs.leftSlider || !refs.rightSlider) return;

  const initialSlide = refs.rightSlider.querySelectorAll(".swiper-slide").length || 0;

  Swiper.use([Autoplay]);

  const leftSwiper = new Swiper(refs.leftSlider, { ...options, autoplay: autoplayOptions });
  const rightSwiper = new Swiper(refs.rightSlider, { ...options, initialSlide });

  leftSwiper.on("slideNextTransitionStart", () => {
    rightSwiper.slidePrev();
  });

  leftSwiper.on("slidePrevTransitionStart", () => {
    rightSwiper.slideNext();
  });

  refs.arrowUp?.addEventListener("click", () => {
    leftSwiper.slidePrev();
  });

  refs.arrowDown?.addEventListener("click", () => {
    leftSwiper.slideNext();
  });
};

const init = () => {
  const heroCarousels = document.querySelectorAll<HTMLElement>("[h-comp='heroCarousel']");

  for (const heroCarousel of heroCarousels) {
    HeroCarousel({ rootEl: heroCarousel });
  }
};

init();
